import { getCache, hasCache, setCache, removeCache } from './cache'

const TOKEN_NAMESPACE = 'token'
const REFRESH_TOKEN_NAMESPACE = 'refresh-token'

export const getToken = (): string => {
  const token = getCache<string>(TOKEN_NAMESPACE)
  return token
}

export const getRefreshToken = (): string => {
  const token = getCache<string>(REFRESH_TOKEN_NAMESPACE)
  return token
}

export const removeToken = (): void => removeCache(TOKEN_NAMESPACE)

export const removeRefreshToken = (): void =>
  removeCache(REFRESH_TOKEN_NAMESPACE)

export const setToken = (token: string): void => {
  setCache(TOKEN_NAMESPACE, token)
}

export const setRefreshToken = (refreshToken: string): void => {
  setCache(REFRESH_TOKEN_NAMESPACE, refreshToken)
}

export const hasToken = (): boolean => hasCache(TOKEN_NAMESPACE)

export const hasRefreshToken = (): boolean => hasCache(REFRESH_TOKEN_NAMESPACE)
